<template>
  <v-list-item @click="$emit('clicked')">
    <v-list-item-avatar class="mr-3">
      <v-avatar color="primary" size="32">
        <span class="white--text">{{ title[0] }}</span>
      </v-avatar>
    </v-list-item-avatar>
    <v-list-item-content class="pa-0">
      <v-list-item-title>{{ title }}</v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: 'ListItemAvatarTwoL',
  props: {
    title: {
      type: String,
      default: 'title'
    },
  }
}
</script>

<style>

</style>